import { useContext } from "react";
import { AttributesContext } from "../../contexts/attributes";

export const useAttributes = () => useContext(AttributesContext);
